import React, { Component } from "react";

class GridContainer extends Component {
  render() {
    return <div className="gridcontainer">{this.props.children}</div>;
  }
}

export default GridContainer;
